import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=252a956e&scoped=true"
import script from "./Workflows.vue?vue&type=script&lang=ts"
export * from "./Workflows.vue?vue&type=script&lang=ts"
import style0 from "./Workflows.vue?vue&type=style&index=0&id=252a956e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a956e",
  null
  
)

export default component.exports